import axios from 'axios';
export const errCheck = (err) => {
    if (err.response.data.statusCode == '401') {
        localStorage.removeItem('token');
        window.location.href = '/login';
    }
};
export default class ReceiptService {
    async getReceiptList(storeName, storeCategory, sdate, edate, sAddress, pName, pcName) {
        return await axios
            .post(`/receipt/receipt_information`, {
                store_name: storeName,
                store_category: storeCategory,
                start_date: sdate,
                end_date: edate,
                store_address: sAddress,
                product_name: pName,
                product_category: pcName,
            })
            .then((res) => res.data.data)
            .catch((err) => {
                errCheck(err);
            });
    }
    async productCategory() {
        return await axios.get(`/category`).then((res) => res.data.categoryData);
    }
    async getExcel(storeName, storeCategory, sdate, edate, sAddress, pName, pcName,dreason) {
        return await axios({
            url: `/receipt/download`,
            method: 'POST',
            responseType: 'blob', // important
            data: {
                store_name: storeName,
                store_category: storeCategory,
                start_date: sdate,
                end_date: edate,
                store_address: sAddress,
                product_name: pName,
                product_category: pcName,
                reason:dreason,
            },
        })
            .then((res) => res)
            .catch((err) => {
                errCheck(err);
            });
    }
    async groupExceldDownload(excelType) {
        return await axios({
            url: `/report/receipt/download`,
            method: 'POST',
            responseType: 'blob', // important
            data: {
                excel_download_type: excelType,
            },
        })
            .then((res) => res)
            .catch((err) => {
                errCheck(err);
            });
    }
    async receiptDetails(uid, sid) {
        return await axios
            .post(`/receipt/receipt_information/details`, { user_id: uid, store_id: sid })
            .then((res) => res.data)
            .catch((err) => {
                errCheck(err);
            });
    }
}
